import { Icon } from '@chakra-ui/react';

export default function SFCheckIconCircleFilled(props) {
  return (
    <Icon
      width='16px'
      height='17px'
      viewBox='0 0 16 17'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M8 16.3281C3.64844 16.3281 0.03125 12.7109 0.03125 8.35938C0.03125 4 3.64062 0.390625 7.99219 0.390625C12.3516 0.390625 15.9688 4 15.9688 8.35938C15.9688 12.7109 12.3594 16.3281 8 16.3281ZM7.125 12.1797C7.39062 12.1797 7.61719 12.0547 7.78125 11.7969L11.4531 6.01562C11.5469 5.85156 11.6484 5.67188 11.6484 5.5C11.6484 5.13281 11.3281 4.89844 10.9844 4.89844C10.7812 4.89844 10.5781 5.02344 10.4297 5.25781L7.09375 10.6172L5.50781 8.57031C5.3125 8.3125 5.14062 8.24219 4.91406 8.24219C4.5625 8.24219 4.28906 8.53125 4.28906 8.88281C4.28906 9.0625 4.35938 9.23438 4.47656 9.39062L6.4375 11.7969C6.64062 12.0703 6.85938 12.1797 7.125 12.1797Z' />
    </Icon>
  );
}
